import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';
import { fireConfetti } from '@/utils/confetti';

export function useMarkPaid() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send(`/api/payments/${id}/mark-paid`, { method: 'POST' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['payments-pending'] });
      qc.invalidateQueries({ queryKey: ['payments-paid'] });
      qc.invalidateQueries({ queryKey: ['payments-history'] });
      fireConfetti();
      toast('Pago marcado como realizado', 'success');
    },
    onError: () => toast('Error al marcar pago', 'error'),
  });
}
